import { PureQueryOptions, RefetchQueriesFunction } from '@apollo/client';
import { CommodityMilestone } from '@bechtel/types';

export interface ReclaimMilestoneFieldprops {
  label: string;
  value: string;
  size?: string;
  translateValues?: boolean;
}
export interface ReclaimMilestoneProps {
  milestone: CommodityMilestone;
  onClose: () => void;
  refetchQueries?: (string | PureQueryOptions)[] | RefetchQueriesFunction;
  onActionCompleted?: () => void;
}
